export const pt = {
  // Navigation (Portuguese)
  explore: 'Explorar',
  search: 'Pesquisar',
  create: 'Criar Post',
  messages: 'Mensagens',
  notifications: 'Notificações',
  settings: 'Configurações',
  profile: 'Perfil',
  logout: 'Sair',
  home: 'Início',
  
  // Authentication
  signin: 'Entrar',
  signup: 'Cadastrar',
  login: 'Entrar',
  register: 'Cadastrar',
  email: 'Email',
  password: 'Senha',
  confirmPassword: 'Confirmar Senha',
  firstName: 'Nome',
  lastName: 'Sobrenome',
  forgotPassword: 'Esqueceu a senha?',
  alreadyHaveAccount: 'Já tem uma conta? Entre',
  dontHaveAccount: 'Não tem uma conta? Cadastre-se',
  
  // Posts & Content
  recent: 'Recente',
  trending: 'Em Alta',
  popular: 'Popular',
  like: 'Curtir',
  likes: 'Curtidas',
  comment: 'Comentário',
  comments: 'Comentários',
  share: 'Compartilhar',
  delete: 'Excluir',
  edit: 'Editar',
  post: 'Post',
  posts: 'Posts',
  title: 'Título',
  content: 'Conteúdo',
  tags: 'Tags',
  noBlogsFound: 'Nenhum blog encontrado. Tente pesquisar por outra coisa ou crie o primeiro!',
  
  // AI Assistant
  quickActions: 'Ações Rápidas',
  writeCaption: 'ESCREVER LEGENDA',
  suggestTopics: 'SUGERIR TÓPICOS',
  improveContent: 'MELHORAR CONTEÚDO',
  creativeIdeas: 'IDEIAS CRIATIVAS',
  clearChat: 'LIMPAR CHAT',
  aiWritingAssistant: 'Assistente de Escrita IA',
  poweredByGroq: 'Alimentado por GROQ AI',
  aiGreeting: 'Oi! Sou seu assistente de escrita IA. Posso ajudá-lo a criar conteúdo envolvente, escrever legendas, sugerir tópicos de posts e melhorar sua escrita. No que gostaria de trabalhar hoje?',
  askMeToHelp: 'Peça-me ajuda com conteúdo, legendas, tópicos ou escrita...',
  aiThinking: 'IA está pensando...',
  
  // Chat & Messages
  chat: 'Chat',
  noConversationsYet: 'Ainda sem conversas',
  ideafluxChat: 'Chat IdeaFlux',
  typeMessage: 'Digite uma mensagem...',
  sendMessage: 'Enviar Mensagem',
  connectingToChat: 'Conectando ao chat...',
  
  // Notifications
  noNotificationsYet: 'Ainda sem notificações.',
  markAllRead: 'Marcar Todas como Lidas',
  clearAll: 'Limpar Todas',
  
  // Settings
  accountSettings: 'Configurações da Conta',
  displayName: 'Nome de Exibição',
  emailAddress: 'Endereço de Email',
  languagePreference: 'Preferência de Idioma',
  privacySecurity: 'Privacidade e Segurança',
  notificationPreferences: 'Preferências de Notificação',
  allowDirectMessages: 'Permitir Mensagens Diretas',
  letOthersMessage: 'Permitir que outros usuários enviem mensagens privadas',
  likesOnPosts: 'Curtidas em posts',
  commentsOnPosts: 'Comentários em posts',
  newFollowers: 'Novos seguidores',
  mentions: 'Menções',
  save: 'Salvar',
  deleteAccount: 'Excluir Conta',
  
  // Notification descriptions
  getNotifiedWhenSomeone: 'Receba notificações quando alguém',
  likesYourPosts: 'curtir seus posts',
  commentsOnYourPosts: 'comentar em seus posts',
  followsYou: 'seguir você',
  mentionsYou: 'mencionar você',
  chooseNotifications: 'Escolha quais notificações deseja receber',
  controlWhoInteracts: 'Controle quem pode interagir com você',
  manageAccountInfo: 'Gerencie as informações e preferências da sua conta',
  emailCannotBeChanged: 'O email não pode ser alterado por motivos de segurança',
  
  // Common
  loading: 'Carregando...',
  cancel: 'Cancelar',
  update: 'Atualizar',
  submit: 'Enviar',
  back: 'Voltar',
  next: 'Próximo',
  previous: 'Anterior',
  online: 'Online',
  offline: 'Offline',
  
  // Profile
  editProfile: 'EDITAR PERFIL',
  noBioYet: 'Ainda sem bio.',
  followers: 'Seguidores',
  following: 'Seguindo',
  recentActivity: 'Atividade Recente',
  noPostsYet: 'Ainda sem posts',
  shareFirstPost: 'Compartilhe seu primeiro post!',
  bio: 'Bio',
  dateOfBirth: 'Data de Nascimento',
  follow: 'Seguir',
  unfollow: 'Deixar de Seguir',
  
  // Search
  discover: 'Descobrir',
  findPeopleStories: 'Encontre pessoas, histórias e ideias que importam para você',
  searchByName: 'Pesquisar por nome, título ou #tag...',
  searchResults: 'Resultados da Pesquisa',
  noResultsFound: 'Nenhum resultado encontrado',
  peopleFound: 'Pessoas Encontradas',
  
  // Settings - Additional keys
  enterDisplayName: 'Digite seu nome de exibição',
  saving: 'Salvando...',
  confirmDeleteAccount: 'Tem certeza de que deseja excluir sua conta? Isso não pode ser desfeito.',
  accountDeletedSuccessfully: 'Conta excluída com sucesso.',
  errorDeletingAccount: 'Erro ao excluir conta. Tente novamente.',
  settingsSavedSuccessfully: 'Configurações salvas com sucesso!',
  failedToSaveSettings: 'Falha ao salvar configurações. Tente novamente.',
  
  // Form component
  pleaseSignInToCreate: 'Faça login para criar um post.',
  titleRequired: 'Título é obrigatório para publicar um post.',
  contentRequired: 'Conteúdo da história é obrigatório para publicar um post.',
  contentTooShort: 'Conteúdo da história deve ter pelo menos 10 caracteres.',
  postUpdatedSuccessfully: 'Post atualizado com sucesso!',
  postPublishedSuccessfully: 'Post publicado com sucesso!',
  pleaseSignInToCreateBlogs: 'Faça login para criar seus próprios blogs IdeaFlux.',
  enterEngagingTitle: 'Digite um título envolvente...',
  story: 'História',
  writeYourMasterpiece: 'Escreva sua obra-prima...',
  addTags: 'Adicionar tags...',
  add: 'Adicionar',
  publishPost: 'Publicar Post',
  
  // Post component
  linkCopiedToClipboard: 'Link copiado para a área de transferência! Contador de compartilhamentos atualizado.',
  youAndOthers: 'Você e {{count}} outros',
  unknownUser: 'Usuário Desconhecido',
  noImage: 'Sem Imagem',
  deletePost: 'Excluir Post',
  confirmDeletePost: 'Tem certeza de que deseja excluir este post?',
};